import { FullScreenLoading } from '@backrs_ui/common-ui';

import { useAppSelector } from '@backrs_ui/grow-ui/src/redux/hooks';

import { BookmarkPage } from './BookmarkPage';

export const BookmarkPageContainer = () => {
  const completedNuggetIds = useAppSelector((state) => state.user.user?.completed_nugget_ids);
  const bookmarks = useAppSelector((state) => state.user.user?.bookmarks);
  const bookmarksLoading = useAppSelector((state) => state.user?.bookmarksLoading);

  const { loading: nuggetsLoading } = useAppSelector((state) => state.contentNugget);

  if (nuggetsLoading || bookmarksLoading) {
    return <FullScreenLoading />;
  }

  return <BookmarkPage completedNuggetIds={completedNuggetIds} bookmarks={bookmarks} />;
};
